import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';
import useStyles from './styles';

export default function FilterForm({
  filterName, fetchBy, label, setPage,
}) {
  const [filterInput, setFilterInput] = useState('');
  const classes = useStyles();

  const handleSearchInputChange = ({ currentTarget }) => {
    setFilterInput(currentTarget.value);
  };

  const handleSearchButtonSubmit = (event) => {
    event.preventDefault();
    fetchBy(filterName, filterInput);
    setPage(0);
  };

  return (
    <form
      className={classes.root}
      noValidate
      autoComplete="on"
      onSubmit={(event) => handleSearchButtonSubmit(event)}
    >
      <TextField
        color="secondary"
        id={filterName}
        label={label}
        variant="outlined"
        onChange={(event) => handleSearchInputChange(event)}
      />
      <Button
        className={classes.searchButton}
        type="submit"
        variant="contained"
        color="secondary"
        startIcon={<SearchIcon />}
      >
        Search
      </Button>
    </form>
  );
}

FilterForm.propTypes = {
  filterName: PropTypes.string.isRequired,
  fetchBy: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
};
